module.exports = __webpack_public_path__ + "img/4.08.1fc1f248.jpg";